import { Toleranzen, ToleranzenAktivOptions, ToleranzenBezeichnungen } from './zaehler.types';

export enum ZählerMode {
  ZÄHLER = 1,
  STELLKRAFT = 2,
}

export const enum ZType {
  NotHeader = 0,
  Header = 6,
  Spurweite = 1,
  Leitweite = 2,
  Rillenweite = 3,
  Querhöhe = 4,
  RadlenkerAbstand = 5,
  ExterneEingabe = 10,
  Zustand = 18,
  Abgeleitete = 29,
  Differenz_SS_SK = 1000,
  Differenz_SH_L = 1001,
  Verwindung = 30,
  Leitweite_CDM = 1002,
  Rillentiefe_CDM = 1003,
}
export const ZTypeLongNames: Map<ZType, string> = new Map([
  [ZType.Spurweite, 'Spurweite'],
  [ZType.Leitweite, 'Leitweite'],
  [ZType.Rillenweite, 'Rillenweite'],
  [ZType.Querhöhe, 'Querhöhe'],
  [ZType.RadlenkerAbstand, 'Radlenkerleiflächenabstand'],
  [ZType.ExterneEingabe, 'Externe Eingabe'],
  [ZType.Zustand, 'Zustand (gut / schlecht)'],
  [ZType.Abgeleitete, 'Abgeleitete Größe'],
  [ZType.Differenz_SS_SK, 'Differenz "ss-sk"'],
  [ZType.Differenz_SH_L, 'Differenz "sh-l"'],
  [ZType.Verwindung, 'Verwindung'],
  [ZType.Leitweite_CDM, '[CDM] Leitweite'],
  [ZType.Rillentiefe_CDM, '[CDM] Rillentiefe'],
]);

export const enum ZArt {
  None = 0,
  Numerisch = 1,
  SollGreat = 2,
  SollEqGreat = 21,
  SollLess = 3,
  SollEqLess = 31,
  Mindestwert = 4,
  Maximalwert = 5,
  ZwischenMinMax = 9,
  JaNein = 6,
}
type SollMinusPlusText = '=' | '<' | '>' | '<=' | '>=' | '>...<' | 'Ja' | '';
export type SollMinusPlusOptions = {
  [key in 'soll' | 'plus' | 'minus']?: {
    text: SollMinusPlusText;
    input: 'Num' | 'Text' | 'Select';
  };
};

export const ZArtOptions: Map<ZArt, SollMinusPlusOptions> = new Map([
  [
    ZArt.Numerisch,
    {
      soll: { input: 'Num', text: '' /* '=' */ },
      plus: { input: 'Num', text: '>' },
      minus: { input: 'Num', text: '<' },
    },
  ],
  [
    ZArt.SollGreat,
    {
      soll: { input: 'Num', text: '>' },
      minus: { input: 'Text', text: '<=' },
    },
  ],
  [
    ZArt.SollEqGreat,
    {
      soll: { input: 'Num', text: '>=' },
      minus: { input: 'Text', text: '<' },
    },
  ],
  [
    ZArt.SollLess,
    {
      soll: { input: 'Num', text: '<' },
      plus: { input: 'Text', text: '>=' },
    },
  ],
  [
    ZArt.SollEqLess,
    {
      soll: { input: 'Num', text: '<=' },
      plus: { input: 'Text', text: '>' },
    },
  ],
  [
    ZArt.Mindestwert,
    {
      soll: { input: 'Text', text: '' /* '>=' */ },
      minus: { input: 'Num', text: '<' },
    },
  ],
  [
    ZArt.Maximalwert,
    {
      soll: { input: 'Text', text: '' /* '<=' */ },
      plus: { input: 'Num', text: '>' },
    },
  ],
  [
    ZArt.ZwischenMinMax,
    {
      soll: { input: 'Text', text: '>...<' },
      plus: { input: 'Num', text: '>' },
      minus: { input: 'Num', text: '<' },
    },
  ],
  [
    ZArt.JaNein,
    {
      soll: { input: 'Select', text: 'Ja' },
    },
  ],
]);

export const ZArtLongNames: Map<ZArt, string> = new Map([
  [ZArt.Numerisch, 'Numerische Toleranzen'],
  [ZArt.SollGreat, 'Ist-Wert <= Soll, dann Ausfall'],
  [ZArt.SollEqGreat, 'Ist-Wert < Soll, dann Ausfall'],
  [ZArt.SollLess, 'Ist-Wert >= Soll, dann Ausfall'],
  [ZArt.SollEqLess, 'Ist-Wert > Soll, dann Ausfall'],
  [ZArt.Mindestwert, 'Ist-Wert < Mindestwert, dann Ausfall'],
  [ZArt.Maximalwert, 'Ist-Wert > Maximalwert, dann Ausfall'],
  [ZArt.ZwischenMinMax, 'Ist-Wert liegt zwischen Min und Max'],
  [ZArt.JaNein, 'Ja/Nein-Prüfung'],
]);

export const enum VerknüpfungsTyp {
  Hauptzähler,
  Wartungszähler,
}

export const enum MessungDropdownList {
  Messender = 'messender',
  Messgerät = 'geraet',
}

export const enum AusfallStatus {
  iO,
  X,
  XX,
  XXX,
}

export const matchTolOption: Record<keyof Toleranzen | keyof ToleranzenAktivOptions, keyof ToleranzenBezeichnungen> = {
  SR100minus: 'TEXT_100_m',
  SR100plus: 'TEXT_100_p',
  aktivSR100: 'TEXT_100_S',

  SRGminus: 'TEXT_G_m',
  SRGplus: 'TEXT_G_p',
  aktivSRG: 'TEXT_G_S',

  SRlimminus: 'TEXT_L_m',
  SRlimplus: 'TEXT_L_p',
  aktivSRlimm: 'TEXT_L_S',

  isSR100: 'TEXT_100_S',
  isSRG: 'TEXT_G_S',
};

export const defaultTolBez: ToleranzenBezeichnungen = {
  //#region Tol SR100
  TEXT_100_m: 'SR100 -',
  TEXT_100_p: 'SR100 +',
  TEXT_100_A: 'SR100',
  TEXT_100_S: 'SR100',
  COLOR_100: '#90EE90',
  //#endregion
  //#region Tol SRLim
  TEXT_L_m: 'SRLim -',
  TEXT_L_p: 'SRLim +',
  TEXT_L_A: 'SRLim',
  TEXT_L_S: 'SRLim',
  COLOR_L: '#FFFF00',
  //#endregion
  //#region Tol SRG
  TEXT_G_m: 'SRG -',
  TEXT_G_p: 'SRG +',
  TEXT_G_A: 'SRG',
  TEXT_G_S: 'SRG',
  COLOR_G: 'FF0000',
  //#endregion
};

export enum TrackMode {
  Anlage,
  Stammgleis,
  Zweiggleis,
  StrangA,
  StrangB,
  StrangC,
  GleisA_C,
  GleisC_A,
  GleisB_D,
  GleisD_B,
  AbzweigA_D,
  AbzweigD_A,
  AbzweigB_C,
  AbzweigC_B,
}
export const TrackModeLongNames: Map<TrackMode, string> = new Map([
  [TrackMode.Anlage, 'Anlage'],
  [TrackMode.Stammgleis, 'Stammgleis'],
  [TrackMode.Zweiggleis, 'Zweiggleis'],
  [TrackMode.StrangA, 'Strang a'],
  [TrackMode.StrangB, 'Strang b'],
  [TrackMode.StrangC, 'Strang c'],
  [TrackMode.GleisA_C, 'Gleis a-c'],
  [TrackMode.GleisC_A, 'Gleis c-a'],
  [TrackMode.GleisB_D, 'Gleis b-d'],
  [TrackMode.GleisD_B, 'Gleis d-b'],
  [TrackMode.AbzweigA_D, 'Abzweig a-d'],
  [TrackMode.AbzweigD_A, 'Abzweig d-a'],
  [TrackMode.AbzweigB_C, 'Abzweig b-c'],
  [TrackMode.AbzweigC_B, 'Abzweig c-b'],
]);
